import { useLocation } from 'react-router-dom';
import { getLangFromUrl } from './langSource';

export function useLang() {
  const location = useLocation();
  return getLangFromUrl(location.pathname);
}
